export default function toggleNav (el) {
    el.addEventListener('click', () => {
        const nav = document.getElementById('dashboardSidebar');
        nav.classList.toggle('hidden');
    });
}